import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// "06/08/2026" -> Date. getSingleMonthlyCashSummary queries without an
// orderBy, so rows arrive in Firestore document order; without this the days
// render scrambled and the previousCash -> remainingBalance chain looks broken
// even when it isn't.
function parseDayId(dateStr) {
  const [day, month, year] = String(dateStr || "").split("/");
  return new Date(
    parseInt(year, 10) || 0,
    (parseInt(month, 10) || 1) - 1,
    parseInt(day, 10) || 1
  );
}

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;
    const rows = [...(myData || [])].sort(
      (a, b) => parseDayId(a.date) - parseDayId(b.date)
    );

    return (
      <Fragment>
        <div className="cs-table-wrap">
          <table className="table cs-table">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Previous Cash</th>
                <th scope="col">Total Cash In</th>
                <th scope="col">Total Cash Out</th>
                <th scope="col">Remaining Cash</th>
                <th scope="col" className="cs-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={6} className="cs-empty">
                    <EmptyState>No records for this month.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{expense.date}</td>
                    <td>{expense.previousCash}Tk</td>
                    <td>
                      <span className="cs-amount-pill cs-amount-pill--in">
                        {expense.totalCashIns}Tk
                      </span>
                    </td>
                    <td>
                      <span className="cs-amount-pill cs-amount-pill--out">
                        {expense.totalCashOuts}Tk
                      </span>
                    </td>
                    <td>{expense.remainingBalance}Tk</td>
                    <td className="cs-col-action">
                      <button
                        type="button"
                        className="cs-icon-btn"
                        onClick={() => {
                          history.push(
                            `/cash-summary-by-day/${String(expense.date).replaceAll(
                              "/",
                              "-"
                            )}`
                          );
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
